const requiredEnvVars = ['VITE_SUPABASE_URL', 'VITE_SUPABASE_ANON_KEY'] as const

export function validateEnv() {
  const missing = requiredEnvVars.filter(
    (key) => !import.meta.env[key]
  )
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}`
    )
  }
}

export const env = {
  get supabaseUrl(): string {
    return import.meta.env.VITE_SUPABASE_URL
  },
  get supabaseAnonKey(): string {
    return import.meta.env.VITE_SUPABASE_ANON_KEY
  },
} as const
